module.exports = __webpack_public_path__ + "static/media/icon1.f8751572.svg";